import { api } from './data-processing-api-instance';

export const linkParsingApi = {
  async parseLink(link: string) {
    const { data: responseData } = await api.post('links/parse-link', { link });
    return responseData as string;
  },
};
